import styled, { css } from "styled-components"

export interface FormFieldProps {
  name?: string
  inline?: boolean
  width?: string

  margin?: string

  error?: string | null
}

const StyledFormField = styled.div<FormFieldProps>`
  display: ${(props) => (props.inline ? "inline-block" : "block")};
  position: relative;
  width: ${(props) => props.width};
  margin: ${(props) => props.margin ?? "0 0 0.75rem 0"};

  ${(props) =>
    props.error &&
    css`
      &::after {
        content: '${props.error}';
        position: absolute;
        top: 0;
        right: 0;
        color: ${props.theme.colors.error};
        font-size: 0.8rem;
      }
    `}
  grid-area: ${(props) => props.name};
`

export const FormField: React.CFC<FormFieldProps> = ({
  width = "100%",
  margin = "0 1rem 1rem 0",

  children,
  ...props
}) => {
  return (
    <StyledFormField width={width} {...props}>
      {children}
    </StyledFormField>
  )
}
